import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ToastService, Toast } from '../../services/toast.service';
import { ThemeService } from '../../services/theme.service';
import { IconComponent } from '../icon/icon.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit {
  toasts$: Observable<Toast[]>;
  currentTheme: string = 'light';

  constructor(private toastService: ToastService, private themeService: ThemeService) {
    this.toasts$ = this.toastService.toasts$;

    // Subscribe to theme changes
    this.themeService.currentTheme$.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnInit(): void {}

  removeToast(id: string): void {
    this.toastService.remove(id);
  }

  trackByToast(index: number, toast: Toast): string {
    return toast.id;
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success':
        return 'bi-check-circle-fill';
      case 'error':
        return 'bi-exclamation-triangle-fill';
      case 'warning':
        return 'bi-exclamation-circle-fill';
      case 'info':
        return 'bi-info-circle-fill';
      default:
        return 'bi-info-circle-fill';
    }
  }

  getIconColor(type: string): string {
    switch (type) {
      case 'success':
        return '#28a745';
      case 'error':
        return '#dc3545';
      case 'warning':
        return '#ffc107';
      case 'info':
        return '#17a2b8';
      default:
        return '#17a2b8';
    }
  }

  getToastBackground(): string {
    return this.currentTheme === 'dark' ? '#2d2d2d' : '#ffffff';
  }

  getToastTextColor(): string {
    return this.currentTheme === 'dark' ? '#ffffff' : '#333333';
  }

  getToastSecondaryTextColor(): string {
    return this.currentTheme === 'dark' ? '#aaaaaa' : '#666666';
  }

  getToastShadow(): string {
    if (this.currentTheme === 'dark') {
      return '0 4px 16px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.3)';
    } else {
      return '0 4px 16px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.08)';
    }
  }

  getToastHoverBackground(): string {
    return this.currentTheme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
  }

  onCloseButtonHover(event: Event, isHovering: boolean): void {
    const button = event.target as HTMLElement;
    if (isHovering) {
      button.style.backgroundColor = this.getToastHoverBackground();
      button.style.color = this.getToastTextColor();
    } else {
      button.style.backgroundColor = 'transparent';
      button.style.color = this.getToastSecondaryTextColor();
    }
  }
}